import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Careers from '@/components/Careers';
import CES from '@/components/CES';
import Office from '@/components/Office';
import Portfolio from '@/components/Portfolio';
import Team from '@/components/Team';
import Header from '@/components/shared/Header';

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/careers',
            name: 'Careers',
            component: Careers
        },
        {
            path: '/ces',
            name: 'CES',
            component: CES
        },
        {
            path: '/office',
            name: 'Office',
            component: Office
        },
        {
            path: '/portfolio',
            name: 'Portfolio',
            component: Portfolio
        },
        {
            path: '/team',
            name: 'Team',
            component: Team
        },
        {
            path: '/header',
            name: 'Header',
            component: Header
        },
        {
            path: '*',
            redirect: '/'
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }else if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});


// WEBPACK FOOTER //
// ./src/router/index.js